export default __webpack_public_path__ + "static/media/pantry1-afterE.f4d558b1.jpg";